import Request from "@/services/api/Request";
import logger from "@/services/Logger";

import { API_URL } from "@/constants";

export const routes = {
  info: `${API_URL}/personal/artist`,
  singles: `${API_URL}/personal/artist/singles`,
  albums: `${API_URL}/personal/artist/albums`,
  update: `${API_URL}/personal/artist/`,
  cover: `${API_URL}/personal/artist/image`,
  genres: `${API_URL}/personal/artist/genres`,
  massUpdate: `${API_URL}/personal/artist/mass-update`
};

export const request = new Request("personal");

export default {
  fetch(type, params = {}) {
    switch (type) {
      case "info":
        return this.info(params);
      case "singles":
        return this.singles(params);
      case "albums":
        return this.albums(params);
      default:
        return Promise.reject("Request type required");
    }
  },
  info(params) {
    return request.get(routes.info, params);
  },
  singles(params) {
    return request.get(routes.singles, params);
  },
  albums(params) {
    return request.get(routes.albums, params);
  },
  update(params) {
    return request.post(routes.update, params);
  },
  genres(params) {
    logger.deprecation("Endpoint personal/genres");
    return request.post(routes.genres, params);
  },
  cover(params) {
    const { image } = params;

    if (image) {
      const formData = new FormData();

      formData.append("image", image);

      return request.post(routes.cover, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }

    return Promise.resolve();
  },
  async save({ title, type, image, deleted = [] }) {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("type", type);

    if (deleted.length) {
      deleted.forEach(item => {
        formData.append("deleted[]", item);
      });
    }

    if (image) {
      formData.append("image", image);
    }

    return request.post(routes.massUpdate, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
